import { fetch } from '@atlassian/eoc-fetch';

import {
	type ContactResponse,
	type ForwardingRulesResponse,
	type MuteResponse,
	type NotificationPreferencesResponse,
	type QuietHoursResponse,
	type RoleBasedNotificationResponse,
} from '../../common/types';

export const getNotificationPreferences = () =>
	fetch<NotificationPreferencesResponse | RoleBasedNotificationResponse>(
		`/v1/users/notification-preferences`,
	);

export const getContact = () => fetch<ContactResponse>(`/v1/users/contact`);

export const getMuteDetail = () => fetch<MuteResponse>(`/v1/users/notifications/mute`);

export const getQuietHoursDetail = () => fetch<QuietHoursResponse>(`/v1/users/quiet-hours/details`);

export const getForwardingRules = () =>
	fetch<ForwardingRulesResponse>(`/v1/alerts/notifications/forwarding-rules`);
